(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-with"]) return;
  try {
    
$(function(){
  //news slide
  var top_slide = new Swiper('.news-slide .swiper-container', {
    loop: true,
    speed: 600,
    watchOverflow: true,
    slidesPerView: 1,
    effect: 'fade',
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    pagination: {
      el: '.swiper-pagination'
    }
  });

  /*fadein animation */
  $(window).scroll(function (){
    $('.fadein').each(function(){
      var elemPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 60){
        $(this).addClass('scrollin');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
